import * as swcHelpers from '@swc/helpers';
import { Util } from '@grandvisionhq/forms';
import { idleState, uninitState, failedState, successState, loadingState } from '@grandvisionhq/state';
import { FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_LIST, FETCH_PRODUCT_DATA_SUCCESS, FETCH_PRODUCT_DATA_FAILED, FETCH_PRODUCT_DATA, QUANTITY_SUCCESS, QUANTITY_FAILED, QUANTITY, PAUSE_SUCCESS, PAUSE_FAILED, PAUSE, CCC_ADDRESS_SET_IS_MODAL_OPEN, CCC_ADDRESS_SET_IS_EDIT_MODE, CCC_ADDRESS_SAVE_FAILED, CCC_ADDRESS_SAVE_SUCCESS, CCC_ADDRESS_SAVE, CCC_ADDRESS_RESET, CCC_ADDRESS_UPDATE, FETCH_DETAIL_SUCCESS, FETCH_DETAIL_FAILED, FETCH_DETAIL } from './actions.js';

const initialState = {
    detailCall: idleState(),
    pauseCall: idleState(),
    quantityCall: idleState(),
    productDataCall: idleState(),
    productData: {},
    cccForm: {
        state: {},
        saveFormCall: idleState(),
        isInEditMode: false,
        isModalOpen: false
    },
    list: uninitState()
};
const getFormState = (address = {})=>{
    const { streetName , addressLine1 , addressLine2 , addressLine3 , additionalStreetInfo , additionalAddressInfo , county , region  } = address, rest = swcHelpers.objectWithoutProperties(address, [
        "streetName",
        "addressLine1",
        "addressLine2",
        "addressLine3",
        "additionalStreetInfo",
        "additionalAddressInfo",
        "county",
        "region"
    ]);
    const mappedAddress = swcHelpers.objectSpread({}, rest, {
        streetName: streetName || addressLine1 || '',
        additionalStreetInfo: additionalStreetInfo || addressLine2 || '',
        additionalAddressInfo: additionalAddressInfo || addressLine3 || '',
        region: region || county || ''
    });
    return Util.fieldsToFormState(mappedAddress);
};
function cccReducer(state = initialState, action) {
    switch(action.type){
        case FETCH_DETAIL:
            let detail = state.detail;
            /* Reset detail data when it's for a different subscription. We still want to re-fetch
       * the subscription because it might have been updated since the last fetch.
       * We can still display the old data until the new data is fetched though
       * so we will just replace it when the call succeeds but until then we leave the old data
       */ if (detail && detail.id !== action.payload.cccSubscriptionId) {
                detail = undefined;
            }
            return swcHelpers.objectSpread({}, state, {
                detailCall: loadingState(),
                detail
            });
        case FETCH_DETAIL_FAILED:
            return swcHelpers.objectSpread({}, state, {
                detailCall: failedState(action.error),
                detail: undefined
            });
        case FETCH_DETAIL_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                detailCall: idleState(),
                detail: action.payload,
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    state: getFormState(action.payload.deliveryAddress)
                })
            });
        case CCC_ADDRESS_UPDATE:
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    state: action.payload
                })
            });
        case CCC_ADDRESS_RESET:
            var ref;
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, initialState.cccForm, {
                    state: getFormState((ref = state.detail) === null || ref === void 0 ? void 0 : ref.deliveryAddress)
                })
            });
        case CCC_ADDRESS_SAVE:
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    saveFormCall: loadingState()
                })
            });
        case CCC_ADDRESS_SAVE_SUCCESS:
            var ref1;
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, initialState.cccForm, {
                    state: getFormState((ref1 = state.detail) === null || ref1 === void 0 ? void 0 : ref1.deliveryAddress),
                    isModalOpen: true
                })
            });
        case CCC_ADDRESS_SAVE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    saveFormCall: failedState(action.error)
                })
            });
        case CCC_ADDRESS_SET_IS_EDIT_MODE:
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    isInEditMode: action.payload
                })
            });
        case CCC_ADDRESS_SET_IS_MODAL_OPEN:
            return swcHelpers.objectSpread({}, state, {
                cccForm: swcHelpers.objectSpread({}, state.cccForm, {
                    isModalOpen: action.payload
                })
            });
        case PAUSE:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: loadingState()
            });
        case PAUSE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: failedState(action.error)
            });
        case PAUSE_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                pauseCall: idleState()
            });
        case QUANTITY:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: loadingState()
            });
        case QUANTITY_FAILED:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: 'reason' in action.payload ? idleState() : failedState(action.payload)
            });
        case QUANTITY_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                quantityCall: idleState()
            });
        case FETCH_PRODUCT_DATA:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: loadingState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productIds.reduce((acc, id)=>swcHelpers.objectSpread({}, acc, {
                        [id]: loadingState()
                    })
                , {}))
            });
        case FETCH_PRODUCT_DATA_FAILED:
            const { error , productData  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                productDataCall: failedState(error),
                productData: swcHelpers.objectSpread({}, state.productData, productData)
            });
        case FETCH_PRODUCT_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                productDataCall: idleState(),
                productData: swcHelpers.objectSpread({}, state.productData, action.payload.productData)
            });
        case FETCH_LIST:
            return swcHelpers.objectSpread({}, state, {
                list: loadingState()
            });
        case FETCH_LIST_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                list: successState(action.payload)
            });
        case FETCH_LIST_FAILED:
            return swcHelpers.objectSpread({}, state, {
                list: failedState(action.error)
            });
        default:
            return state;
    }
}

export { cccReducer, initialState };
//# sourceMappingURL=reducer.js.map
